



















import { Component, Prop, Vue } from 'vue-property-decorator'
import SudokuPossibilities from './SudokuPossibilities.vue'
import Solver from '../classes/solver'
import Destroyer from '../classes/destroyer'
import { getBoxIndicies } from '../utils'

@Component({
  components: {
    SudokuPossibilities
  }
})
export default class PuzzleBoard extends Vue {
  @Prop() private puzzle!: number[][];
  @Prop() private locked!: boolean[][];
  @Prop() private solvers!: Solver[];
  @Prop() private destroyers!: Destroyer[];
  @Prop() private noClicks!: number[][];
  @Prop() private noAutos!: number[];
  @Prop() private guesses!: number[][];

  isAutoBlocked (noAuto: number, x: number, y: number) {
    if (noAuto < 9) {
      // col
      return noAuto === x
    } else if (noAuto < 18) {
      return noAuto - 9 === y
      // row
    } else {
      // box
      const indicies = getBoxIndicies(noAuto - 18)
      return indicies.some((index) => index[0] === x && index[1] === y)
    }
  }
}
